module.exports = __webpack_public_path__ + "img/chemistry.beb76f2d.jpg";